import FormattedMessage from 'I18n/components/FormattedMessage';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { SuccessIcon } from 'foundations-assets';
import { Flex } from 'foundations-components/components/Flex';
import { IconHolder } from 'foundations-components/transitional/components/IconHolder';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const AttachPdfField = ({
  label
}) => {
  return /*#__PURE__*/_jsx(View, {
    marginBlockStart: "500",
    as: "div",
    children: /*#__PURE__*/_jsxs(Flex, {
      display: "inline-flex",
      alignItems: "center",
      children: [/*#__PURE__*/_jsx(IconHolder, {
        icon: SuccessIcon,
        color: "icon-core-subtle",
        size: "600",
        marginInlineEnd: "200",
        padding: "0"
      }), /*#__PURE__*/_jsx(Text, {
        typography: "body-200",
        children: label || /*#__PURE__*/_jsx(FormattedMessage, {
          message: "CommerceToolsUiLib.shareToolModal.emailTab.attachPdfField.label"
        })
      })]
    })
  });
};